import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import WorkspaceSettingsContainer from './containers/WorkspaceSettingsContainer';
import ConnectorCreateContainer from './containers/ConnectorCreateContainer';
import ConnectorEditContainer from './containers/ConnectorEditContainer';
import ServiceSelectionContainer from './containers/ServiceSelectionContainer';
import { useRouteMatch } from 'react-router-dom';

function WorkspaceSettingsRouter() {
  const match = useRouteMatch();

  return (
    <Switch>
      {/* Connector creation - service selection */}
      <Route
        exact
        path={`${match.path}/connectors/new`}
        component={ServiceSelectionContainer}
      />

      {/* Connector creation - direct configuration */}
      <Route
        exact
        path={`${match.path}/connectors/new/:serviceId`}
        component={ConnectorCreateContainer}
      />

      {/* Connector editing */}
      <Route
        exact
        path={`${match.path}/connectors/:connectorId/edit`}
        component={ConnectorEditContainer}
      />

      {/* Core workspace settings */}
      <Route
        exact
        path={`${match.path}`}
        component={WorkspaceSettingsContainer}
      />

      {/* Default redirect to main settings */}
      <Redirect from={`${match.path}/*`} to={match.path} />
    </Switch>
  );
}

export default WorkspaceSettingsRouter;
